var $ = require('jquery');

// console.log($('.wp-forms-container'));

var countLimit = 100; var currentCount = 0;
var formInterval = setInterval(function() {
    currentCount++;
    if ( $('.wpforms-container').length ) {
        clearInterval(formInterval);
        forms();
    } else if ( countLimit == currentCount ) {
        clearInterval(formInterval);
    }
}, 250);

function forms() {
    $('.wpforms-container').each(function() {
        var _this = $(this);
        var submitButton = _this.find('button[type="submit"].wpforms-submit');
        console.log(submitButton);
        _this.find('button[type="submit"].wpforms-submit').wrap('<div class="button is-style-button--sprout-with-arrow">');
    })
}
